var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"campaign"},[_c('Header',{attrs:{"user":_vm.user}}),_c('main',{staticClass:"main"},[_c('ViewBilling')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }